import { useCallback, useMemo, useState } from 'react';
import { Notification, Promotions } from 'models';
import { availableNotifications } from 'constants/availableNotifications';

const filterAndSortNotifications = (list: Notification[]) =>
  list.filter(({ isVisible }) => !!isVisible).sort((a, b) => a.priority - b.priority);

export const useNotifications = () => {
  const [notificationsList, setNotificationsList] =
    useState<Notification[]>(availableNotifications);

  const updateNotification = useCallback((id: Promotions, overrides: Partial<Notification>) => {
    setNotificationsList((list) => {
      const updatedNotifications = list.map((notification) =>
        notification.id === id ? { ...notification, ...overrides } : notification
      );

      return updatedNotifications;
    });
  }, []);

  const notifications = useMemo(
    () => filterAndSortNotifications(notificationsList),
    [notificationsList]
  );

  return [notifications, updateNotification] as const;
};
